import _ from "lodash";

import { reduceList, reduceListExtra } from "./utils";

const base = "https://www.strawpoll.me/api/v2/polls";

const pollDataUrl = id => `${base}/${id}`;

const getJson = res => res.json();

const pollData = id => fetch(pollDataUrl(id)).then(getJson);

const makeKey = id => (item, idx) => "_" + id + "_option" + (idx + 1);

let polls = {};

setInterval(() => {
  Object.keys(polls).forEach(h => polls[h]());
}, 10000);

const getPoll = (params, id, cb) => {
  pollData(params.id).then(json => {
    cb(
      {
        title: { type: "text", value: json.title },
        total: { type: "number", value: _.sum(json.votes) },
        options: reduceList(json.options, makeKey(id), true)
      },
      reduceListExtra(
        json.options,
        makeKey(id),
        (c, i) => ({
          label: { type: "text", value: c },
          votes: { type: "number", value: json.votes[i] },
          score: { type: "progress", value: json.votes[i] * 100 / _.sum(json.votes) }
        }),
        "strawpoll.options"
      )
    );
  });
};

export default (params, id, cb) => {
  polls[id] = () => getPoll(params, id, cb);
  getPoll(params, id, cb);
};



// WEBPACK FOOTER //
// ./src/spreadsheet/providers/strawpoll.js